import React from "react";
import { buttonClass } from "../utils/buttonStyles";

export default function UIButton({
  as: Component = "button",
  theme = "light",
  variant = "secondary",
  size = "md",
  className = "",
  children,
  ...props
}) {
  return (
    <Component
      className={buttonClass({ theme, variant, size, className })}
      {...props}
    >
      {children}
    </Component>
  );
}
